module.exports = __webpack_public_path__ + "img/sunset.ddacbfa7.svg";